export default "__VITE_PUBLIC_ASSET__e8419218__"